import { Routes, Route, Navigate } from 'react-router-dom';
import ClientDashboard from './ClientDashboard';

export default function ClientRouter() {
  return (
    <Routes>
      <Route path="" element={<ClientDashboard />} />
      <Route path="dashboard" element={<Navigate to="../" replace />} />
    </Routes>
  );
}
